<template>
  <div class="personal-center">
    <div class="header">
      <div class="header-wrapper">
        <div class="user-info">
          <div class="user-icon">
            <img alt src="../assets/img/home-change/icon-user.png" />
          </div>
          <div class="user-intro">
            <div class="phone">{{ userInfo.phone }}</div>
            <p v-if="userInfo.company">{{ userInfo.company }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-center-wrapper" v-show="mainModules.length">
      <div class="modules-entry">
        <a
          :key="index"
          @click="moduleJumpRouter(configer)"
          class="module-item"
          href="javascript:;"
          v-for="({ configer }, index) in mainModules"
        >
          <div class="module-icon">
            <img :alt="configer.title" v-lazy="configer.img" />
          </div>
          <span class="title">{{ configer.title }}</span>
          <span class="subtitle">{{ configer.subtitle }}</span>
        </a>
      </div>
      <div class="other-modules-entry" v-show="otherModules.length">
        <!-- <div class="title">更多服务</div> -->
        <div class="other-modules">
          <a
            :key="index"
            @click="moduleJumpRouter(configer)"
            class="module-item"
            href="javascript:;"
            v-for="({ configer }, index) in otherModules"
          >
            <div class="module-icon">
              <img :alt="configer.title" v-lazy="configer.img" />
              <span>{{ configer.title }}</span>
            </div>
            <i>{{configer.num}}</i>
          </a>
        </div>
      </div>
    </div>
    <div class="logout">
      <button @click="logout">退出登录</button>
    </div>
    <div class="footer">
      - 我是有底线的
      <em>({{ userInfo.channel }})</em>
      -
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import api from '../utils/api'
let flag = false
export default {
  name: 'personalCenter',
  data () {
    return {
      mainModules: [],
      otherModules: [],
      loveInfor: null,
      EGInfo: null
    }
  },
  computed: {
    ...mapState('store', ['userInfo', 'rebateInfo'])

  },
  created () {
    this.init()
    this.getRebateInfo()
    this.getLoveAccount()
  },
  activated () {
    this.getUserInfo()
    this.fetchEGAccount()
  },
  methods: {
    ...mapMutations('store', ['setUserInfo', 'getUserAuthorization']),
    ...mapActions('store', [
      'getUserInfo', 'getRebateInfo'
    ]),

    // 模块跳转
    moduleJumpRouter (configer) {
      api.configJumpDetails(configer)
    },

    /**
     * 初始化数据
     */
    async init () {
      this.getMainModules()
      await this.getOtherModules()
      this.fetchEGAccount()
    },

    async getMainModules () {
      const data = await api.getLocationCodingHandler('user-1-1')
      if (data) {
        this.mainModules = data
      }
    },

    async getOtherModules () {
      const data = await api.getLocationCodingHandler('user-1-2')
      if (data) {
        setTimeout(() => {
          data.forEach((item, i) => {
            if (item.configer.title === '福利金') {
              item.configer.num = this.rebateInfo.account
            }
            if (item.configer.title === '爱心币' && this.loveInfor) {
              item.configer.num = this.loveInfor.account_love
            }
          })
          this.otherModules = data
        }, 360)
      }
    },

    // 获取爱心币数量
    async getLoveAccount () {
      const res = await this.$axios.get('api/member/account_love')
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.loveInfor = data
        } else {
          this.$toast(msg)
        }
      }
    },

    // 获取体验金数量
    async fetchEGAccount () {
      const res = await this.$axios.get('api/member/account_experience')
      const { code, data, msg } = res.data
      if (code === 0) {
        this.EGInfo = data

        const egItem = this.otherModules.find((item) => item.configer.title === '体验金')
        if (egItem && this.EGInfo) {
          this.$set(egItem.configer, 'num', this.EGInfo.account_experience)
        }
      } else {
        this.$toast(msg)
      }
    },

    /**
     * 退出
     */
    async logout () {
      if (flag) {
        return false
      }
      flag = true
      await this.$axios.get('api/auth/logout')
      this.$store.dispatch('chat/logout')
      this.getUserAuthorization(null)
      this.setUserInfo(false)
      this.selectedGender = '未知'
      this.userBirthday = '请完善'
      this.$toast('退出成功')
      setTimeout(() => {
        this.$router.push({ name: 'home' })
        flag = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  padding: 0 0.3rem;
  background: url(../assets/img/personal-center/banner.png);
  background-size: 100% auto;
  width: 100%;
  height: 2.41rem;
  box-sizing: border-box;
  .header-wrapper {
    .flex-between;
    padding: 0.6rem 0;
    .user-info {
      .flex-center;
      .user-icon {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.2rem;
      }
      p {
        font-size: @fz22;
        color: #ffffff;
        margin-top: 0.1rem;
        opacity: 0.2;
      }
      .phone {
        color: #f6ddb8;
        font-weight: bold;
        font-size: @fz34;
      }
      .time {
        font-size: @fz22;
        color: #faf8f8;
        padding-top: 0.15rem;
      }
    }
  }
}
.modules-entry {
  padding: 0 0.2rem;
  // margin-top: 0.2rem;
  margin: 0.2rem 0.24rem 0;
  border-radius: .1rem;
  min-height: 2.26rem;
  background-color: #fff;
  .flex-between;
  align-items: flex-start;
  .module-item {
    width: 33.33%;
    padding: 0.3rem 0;
    font-size: @fz28;
    color: #5a5a5a;
    .flex-column-center;
    .module-icon {
      width: 0.7rem;
      height: 0.7rem;
      padding-bottom: 0.1rem;
      img {
        object-fit: contain;
      }
    }
    .subtitle {
      .flex-center;
      height: 0.5rem;
      padding: 0 0.3rem;
      color: #bcbcbc;
      font-size: @fz22;
      text-align: center;
      margin-top: 0.14rem;
    }
  }
}
.other-modules-entry {
  // margin-top: 0.2rem;
  margin: 0.2rem 0.24rem 0;
  border-radius: .1rem;
  background-color: #fff;
  // .title {
  //   font-size: @fz32;
  //   color: #323238;
  //   font-weight: bold;
  // }
  .other-modules {
    .flex-between-wrap;
    .module-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: .88rem;
      color: #404040;
      font-size: @fz26;
      width: 100%;
      border-bottom: 1px solid #E4E4E4;
      padding: 0 .67rem 0 .26rem;
      background: url(../assets/img/personal-center/icon-right.png) no-repeat right .3rem center;
      background-size: 0.08rem 0.14rem;
      .module-icon {
        // padding-bottom: 0.1rem;
        img {
          width: 0.45rem;
          height: 0.45rem;
          object-fit: contain;
          margin-right: .18rem;
        }
        span{
          line-height: .55rem;
        }
      }
    }
    .module-item:last-child{
      border-bottom: none;
    }
  }
}
.personal-center {
  .personal-center-wrapper {
    font-size: @fz24;
    color: @base;
  }
  .logout {
    text-align: center;
    margin-top: 0.5rem;
    button {
      width: 6.8rem;
      height: 0.88rem;
      color: #3498db;
      font-size: @fz28;
      background-color: #fff;
      border-radius: 30px;
    }
  }
  .footer {
    padding-bottom: 0.4rem;
    text-align: center;
    font-size: @fz26;
    color: @c80;
  }
}
</style>
